import { GraphQLQuery, GraphQLService } from 'services/GraphQLService/GraphQLService';
import { AxiosInstance } from 'axios';
import { Device, DeviceLoadType } from 'models/Device/Device';
import { BaseRecordService } from 'utils/BaseRecordService/BaseRecordService';
import { Mapper } from 'services/DataStore/DataStore';
import _defaults from 'lodash/defaults';

export interface ReservationResponse {
    sharedIdentifier: string;
    eventChannel: string;
    registrationCode: string;
}

export default class DeviceRegistrationService extends BaseRecordService<Device> {
    constructor(
        readonly graphQlService: GraphQLService,
        mapper: Mapper<Device>,
        readonly axios: AxiosInstance
    ) {
        super(graphQlService, mapper);
    }

    public async reserveRegistrationCode(): Promise<ReservationResponse> {
        const response = await this.axios.post<ReservationResponse>('/device/registration/reserve');
        //console.log('reservation response', {reservation: response.data});
        return response.data as ReservationResponse;
    }

    registerDeviceWithDisplay(
        locationId: string,
        options: {
            code: string,
            screenId?: number,
            loadType?: DeviceLoadType,
            loadColor?: string|null,
        }
    ): Promise<Device> {
        options = _defaults(options, {loadType: 'LOGO', screenId: 1});
        // console.log('registering device with display', {locationId, options});
        const query: GraphQLQuery = {
            query: `mutation registerDeviceWithDisplay($input: RegisterDeviceWithLocationInput!) {
                registerDeviceWithLocation(input: $input) {
                    device {
                        id
                        locationId
                        config {
                            code
                            screenId
                            loadType
                            loadColor
                        }
                    }
                    clientMutationId
                }
            }`,
            variables: {
                input: {
                    locationId: locationId,
                    deviceRegistrationCode: options.code,
                    config: {
                        ...options
                    }
                },
            },
        };

        return this.graphQlService.mutate(query, { rejectOnError: true });
    }
}
